import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ValidationsService } from '../../services/common/validations.service';
declare var $: any;

@Component({
  selector: 'app-roadmap',
  templateUrl: './roadmap.component.html',
  styleUrls: ['./roadmap.component.scss']
})
export class RoadmapComponent implements OnInit {

  isLandingScreen = false;    // initially true

  testTabsData = [];
  activeTab;

  constructor(private formBuilder: FormBuilder, private validationService: ValidationsService, private dashboardService: DashboardService) {
    this.dashboardService.setRoadmapTabFlag('preferences');
  }

  ngOnInit() {

  }

  goBack() {
    this.isLandingScreen = true;
  }

  setRoadmapTabFlag(data) {
    this.dashboardService.setRoadmapTabFlag(data);
  }

}
